




































































import Vue from "vue";
import { setLayoutOffset } from "@/encoding/scripts/layout";
import { Trans } from "../scripts/helpers/translation/translation";

const STORAGE_DISMISS_KEY = "dismiss-legacy-browser-banner";
const DISMISS_DURING_HOURS = 14;

export default Vue.extend({
    data: function() {
        return {
            isMobile: true,
            lastDismissalAt: null as number | null,
        };
    },

    computed: {
        isLegacyBrowser: function(): boolean {

            /**
             * Instead of sniffing the user agent, we define legacy browsers by
             * their lack of Array.flat() support, because it is:
             * - not supported in IE11
             * - supported in Safari 12, but not 11.x;
             * - supported in Edge Chromium, but not in EdgeHTML.
             *
             * This matches our situation and don’t put aside other browsers.
             * See https://caniuse.com/array-flat.
             */
            return !Array.prototype.flat;
        },

        nextBannerAt: function(): Date | null {
            if (this.lastDismissalAt) {
                const nextVisibilityAt = new Date(this.lastDismissalAt);
                nextVisibilityAt.setHours(nextVisibilityAt.getHours() + DISMISS_DURING_HOURS);
                return nextVisibilityAt;
            }

            return null;
        },

        isVisible: function(): boolean {
            const now = new Date();

            const visibleBefore = new Date(2021, 10, 1); // 2021-11-01 00:00:00
            return this.isLegacyBrowser
                && now < visibleBefore
                && (!this.nextBannerAt || now > this.nextBannerAt);
        },

        browserUpdateUrl: function(): string {
            const urls: Record<string,string> = {
                fr: `${process.env.VUE_APP_IMMOWEB_URL}/fr/navigateur-obsolete`,
                en: `${process.env.VUE_APP_IMMOWEB_URL}/en/outdated-browser`,
                nl: `${process.env.VUE_APP_IMMOWEB_URL}/nl/verouderde-browser`,
            };
            return urls[Trans.currentLocale] ?? "";
        },
    },

    created: function() {
        // Check for previously dissmised banner.
        const previousDismissalAt = localStorage.getItem(STORAGE_DISMISS_KEY);
        this.lastDismissalAt = previousDismissalAt ? parseInt(previousDismissalAt) : null;
    },

    mounted: function() {
        Vue.nextTick(() => {
            this.$responsive.registerMediaQuery("from-desktop", () => {
                this.isMobile = false;
            }, () => {
                this.isMobile = true;
            });
        });
    },

    methods: {
        dismiss: function(): void {
            const dismissalAt = (new Date()).getTime();
            localStorage.setItem(STORAGE_DISMISS_KEY, dismissalAt.toString());
            this.lastDismissalAt = dismissalAt;
        },

        setBannerOffset: function() {
            Vue.nextTick(() => {
                setLayoutOffset(this.isMobile, false);
            });
        },
    },
});
